import React, { useEffect } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Rating from '@mui/material/Rating';
import Typography from '@mui/material/Typography';

import actions from '../../../redux/actions';
import { RootState } from '../../../redux/store';
import { PageContainer, PageSection } from '../../../ui';
import { colors } from '../../../theme/tokens';

/* Tester → Reviews: what customers wrote about the tester */
const CustomerReviews: React.FC = () => {
  const dispatch = useDispatch();
  const { customerReviews, resolution } = useSelector((state: RootState) => state);
  const isMobile = resolution.device === 'mobile' || resolution.device === 'mobile-tablet';
  const reviews: any[] = (customerReviews as any[]) || [];

  useEffect(() => {
    dispatch(actions.listOwnCustomerReviews());
  }, []);

  return (
    <PageContainer isMobile={isMobile}>
      <PageSection title={`Customer reviews${reviews.length ? ` (${reviews.length})` : ''}`} padding={isMobile ? 1.5 : 2.5}>
        {reviews.length ? (
          reviews.map((review, i) => (
            <Box key={i} sx={{ display: 'flex', gap: 2, py: 2, borderTop: i ? '1px solid #f0f3f8' : 'none' }}>
              <Avatar src={review.reviewerAvatarUrl || undefined} alt={review.ownerCompanyName} sx={{ width: 44, height: 44 }} />
              <Box sx={{ flex: 1, minWidth: 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
                  <Typography sx={{ fontWeight: 600 }}>{review.ownerCompanyName}</Typography>
                  <Rating value={Number(review.rating) || 0} readOnly size="small" />
                </Box>
                <Typography variant="body2" sx={{ my: 0.75, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{review.text}</Typography>
                <Typography sx={{ fontSize: 12, color: colors.textGrey }}>
                  {review.cycleTitle} · {moment(review.createdAt).format('DD MMM YYYY')}
                </Typography>
              </Box>
            </Box>
          ))
        ) : (
          <Typography variant="body2" color="textSecondary">No reviews so far</Typography>
        )}
      </PageSection>
    </PageContainer>
  );
};

export default CustomerReviews;
